import { Route, HashRouter as Router, Routes } from "react-router-dom";

import { EditUseCaseView, UseCasesLayout } from "../presentation/use-cases";

import {
  AdminCategoriesView,
  AdminLayoutView,
  AdminTypologiesView,
  AdminView,
  CreateWorkshopView,
} from "../presentation/admin";

import {
  EditWorkShopView,
  WorkshopsLayoutView,
  WorkShopsView,
} from "../presentation/workshops";

import {
  LoginRoute,
  LoginView,
  SignupRoute,
  SignupView,
} from "../presentation/auth";
import { AuthLayout } from "../presentation/auth/views/auth.layout";
import { CatalogLayout, CatalogView } from "../presentation/catalog";
import { DevBoostDetail, DevBoostEdit, DevBoostLayout, DevBoostView } from "../presentation/dev-boost";

import { FactoryLayout, FactoryView } from "../presentation/factory";
import {
  LaboratoryLayout,
  LaboratoryView,
} from "../presentation/laboratory";
import { ShowUseCaseView } from "../presentation/use-cases/views/show-use-case.view";
import { WelcomeLayout, WelcomeView } from "../presentation/welcome";
import { WorkshopDetails } from "../presentation/workshops/view/WorkshopDetails";
import { PrivateRoute } from "../providers";
const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/auth" element={<AuthLayout />}>
          <Route path={LoginRoute} element={<LoginView />} />
          <Route path={SignupRoute} element={<SignupView />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/usecases" element={<UseCasesLayout />}>
            <Route
              path={"/usecases/:useCaseId/edit"}
              element={<EditUseCaseView />}
            />
          </Route>

          <Route path="/workshops" element={<WorkshopsLayoutView />}>
            <Route index element={<WorkShopsView />} />
            <Route path="/workshops/:id" element={<WorkshopDetails />} />
            <Route
              path="/workshops/:workshopId/edit"
              element={<EditWorkShopView />}
            />
          </Route>

          <Route path="/laboratory" element={<LaboratoryLayout />}>
            <Route index element={<LaboratoryView />} />
          </Route>

          <Route path="/admin" element={<AdminLayoutView />}>
            <Route index element={<AdminView />} />
            <Route path="/admin/categories" element={<AdminCategoriesView />} />
            <Route path="/admin/typologies" element={<AdminTypologiesView />} />
            <Route
              path="/admin/workshops/create"
              element={<CreateWorkshopView />}
            />
          </Route>
          <Route path="/factory" element={<FactoryLayout />}>
            <Route index element={<FactoryView />} />
          </Route>
        </Route>
        <Route path="/" element={<WelcomeLayout />}>
          <Route index element={<WelcomeView />} />
        </Route>
        <Route path="/catalog" element={<CatalogLayout />}>
          <Route index element={<CatalogView />} />
        </Route>
        <Route path="/usecases" element={<UseCasesLayout />}>
          <Route path="/usecases/:useCaseId" element={<ShowUseCaseView />} />
        </Route>
        <Route path="/dev-boost" element={<DevBoostLayout />}>
          <Route index element={<DevBoostView />} />
          <Route path="/dev-boost/:id" element={<DevBoostDetail />} />
          <Route path="/dev-boost/:devboostId/edit" element={<DevBoostEdit />} />
        </Route>
        <Route path="*" element={<div>Esta ruta no existe: 404</div>} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
